import * as React from 'react';
import { useGlobalContext } from 'Context/GlobalContext'
import { Skeleton, Grid, Avatar } from "@mui/material";

const SkeletonCedulas = () => {
    const { responsiveScreen } = useGlobalContext();

    return (
        <Grid 
            container 
            columns={{ xs: 1, sm: 3 }}
            sx={{
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            {Array.from(Array(responsiveScreen ? 1 : 6)).map((_, index) => (   
                <Grid key={index} container spacing={2} width={430} sx={{ margin: 1 }}>
                    <Grid 
                        container 
                        spacing={.5} 
                        item 
                        sx={{
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                        xs={12}
                    >
                        <Grid item xs={4}>
                            <Skeleton 
                                variant="rectangular"
                                height={58}
                            />
                        </Grid>
                        <Grid item xs={4}>
                        </Grid>
                        <Grid item xs={2}>
                            <Skeleton variant="circular">
                                <Avatar />
                            </Skeleton>
                        </Grid>
                        <Grid item xs={2}>
                            <Skeleton variant="rectangular" height={58}/>
                        </Grid>
                    </Grid>    
                    <Grid item xs={12}>
                        <Skeleton variant="rounded" height={271}/>
                    </Grid>
                    <Grid container spacing={2} item xs={12}>
                        <Grid item xs={4}>
                            <Skeleton variant="rounded" height={54}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Skeleton variant="rounded" height={54}/>
                        </Grid>
                        <Grid item xs={4}>
                            <Skeleton variant="rounded" height={54}/>
                        </Grid>
                    </Grid>
                </Grid>
            ))}
        </Grid>
    );
}

export default SkeletonCedulas;